<div class="press-details-wrapper">
    <div class="press-release">
        <span>{{textDirection=='rtl' ? pressReleaseDetails?.createdBy:pressReleaseDetails?.createdBy}}</span>
        <h4>{{textDirection=='rtl' ? pressReleaseDetails?.titleAr:pressReleaseDetails?.titleEn}}</h4>
        <img [src]="pressReleaseDetails?.imageUrl" alt="Press">
        <p>{{textDirection=='rtl' ? pressReleaseDetails?.contentAr:pressReleaseDetails?.contentEn}}</p>

    </div>
</div>